import styled, { keyframes } from "styled-components";
import { shade } from "polished";

export const Container = styled.div`
  position: relative;
  background: #f3f4f6;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1100px) {
    margin-top: 32px;
    height: auto;
    align-items: flex-start;
    padding: 20px;
  }
  @media (max-height: 790px) {
    height: auto;
    align-items: flex-start;
    padding: 20px;
  }
`;

export const LanguageSelectorContainer = styled.div`
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 100;

  /* Estilo específico para página Self Service com background escuro */
  button {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 2px solid rgba(255, 255, 255, 0.8) !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;

    &:hover {
      background: rgba(255, 255, 255, 1) !important;
    }
  }

  @media (max-width: 1100px) {
    top: 20px;
    right: 20px;
  }

  @media (max-width: 768px) {
    top: 15px;
    right: 15px;
  }
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimatedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  animation: ${appearFromLeft} 1s;

  form {
    margin: 32px 0 20px 0;
    width: 100%;
    max-width: 450px;
    @media (max-width: 360px) {
      width: 95vw;
    }
    text-align: center;
    h1 {
      margin-bottom: 32px;
    }
    a {
      color: ${shade(0.2, "#002244")};
      display: block;
      margin-top: 16px;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }
  > a {
    color: #ff9000;
    margin-top: 32px;
    text-decoration: none;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    &:hover {
      color: ${shade(0.2, "#ff9000")};
    }
    svg {
      margin-right: 20px;
    }
  }
`;

export const BoxLogin = styled.div`
  width: 100%;
  max-width: 500px;
  min-width: 380px;
  padding: 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);

  @media (max-width: 480px) {
    min-width: auto;
    padding: 28px;
    margin: 0 20px;
  }
`;

export const AreaImageSlug = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormLogin = styled.div`
  width: 100%;
  margin-top: 50px;
  color: #022343;
`;

export const ButtonSubmitLogin = styled.button`
  background: #004e9b;
  color: #fff;
  border-radius: 8px;
  height: 50px;
  width: 100%;
  border: none;
  font-weight: 600;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;

  &:hover {
    background: #003d7a;
    transition: background-color 0.2s ease;
  }

  &:active {
    background: #002d5a;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const BoxBusiness = styled.div`
  margin-top: 20px;
  width: 100%;
  max-width: 500px;
  min-width: 380px;
  padding: 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);

  @media (max-width: 480px) {
    min-width: auto;
    padding: 28px;
    margin: 20px 20px 0;
  }
`;

export const AreaImageBusiness = styled.div`
  display: flex;
  justify-content: center;
`;

export const CustomForm = styled.form`
  margin: 0 !important;
  padding: 0;
  width: 100% !important;
  box-sizing: border-box;
`;

export const InputContainer = styled.div`
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #444;
  font-size: 16px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  text-align: left;
`;

export const CustomInput = styled.input`
  width: 100%;
  height: 50px;
  padding: 14px 28px 12px 28px;
  border-radius: 8px;
  border: ${(props) =>
    props.$hasError ? "2px solid #ff4d4f" : "2px solid #c7c9d9"};
  background: #fff;
  color: #333;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  font-family: "Open Sans", sans-serif;
  box-sizing: border-box;
  margin: 0;

  &::placeholder {
    color: #999;
  }
`;

export const ErrorMessage = styled.div`
  color: #ff4d4f;
  font-size: 14px;
  margin-top: 6px;
  margin-left: 0;
  margin-right: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
`;
